export const DEVICES_OVERVIEW_GET_DATA_REQUEST = "DEVICES_OVERVIEW_GET_DATA_REQUEST";
export const DEVICES_OVERVIEW_GET_DATA_RESULT = "DEVICES_OVERVIEW_GET_DATA_RESULT";

export const DEVICES_OVERVIEW_REFRESH_FIRMWARES = "DEVICES_OVERVIEW_REFRESH_FIRMWARES";
export const DEVICES_OVERVIEW_REFRESH_FIRMWARES_RESULT = "DEVICES_OVERVIEW_REFRESH_FIRMWARES_RESULT";

export const DEVICES_OVERVIEW_GET_CTC_INFO_REQUEST = "DEVICES_OVERVIEW_GET_CTC_INFO_REQUEST";
export const DEVICES_OVERVIEW_GET_CTC_INFO_RESULT = "DEVICES_OVERVIEW_GET_CTC_INFO_RESULT";